function createChangeCartFromEditLayerEvent(orderCartItem, quantity, pageViewId) {
    const singleFormerPrice = orderCartItem.formerSinglePriceValue ? orderCartItem.formerSinglePriceValue : 0.0;
    return {
        styleId: orderCartItem.itemId,
        strikeOutPrice: singleFormerPrice,
        displayedPrice: orderCartItem.singlePriceValue,
        artNr: orderCartItem.itemNumber,
        artGr: orderCartItem.itemOptionName,
        availability: orderCartItem.availabilityType,
        quantity: quantity,
        pageViewId: pageViewId
    };

}
export default {
    createChangeCartFromEditLayerEvent
}
